export function getReportDesignerActions({
  reportId,
  ownership,
  sourceAuthoringEnabled
}) {
  const persisted = Boolean(reportId);
  const systemTemplate = persisted && ownership === "SYSTEM";
  const userReport = persisted && ownership === "USER";

  return {
    saveAsUserReport: !persisted,
    saveAsTemplate: !persisted && sourceAuthoringEnabled,
    save: userReport || (systemTemplate && sourceAuthoringEnabled),
    moveToTemplate: userReport && sourceAuthoringEnabled,
    rename: userReport || (systemTemplate && sourceAuthoringEnabled),
    delete: userReport || (systemTemplate && sourceAuthoringEnabled),
    clone: persisted,
    readOnly: systemTemplate && !sourceAuthoringEnabled
  };
}
